import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withCookies } from 'react-cookie';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Toolbar from '@material-ui/core/Toolbar';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import RadioGroup from '@material-ui/core/RadioGroup';

import moment from "moment";
import Calendar from "react-big-calendar";
import CardHeader from "../../modules/Card/CardHeader.jsx";
import ReadOnlyFormComponent from '../Timesheet/ReadOnlyFormComponent';
import ReadOnlyFormComponentTW from '../Timesheet/ReadOnlyFormComponentTW';
import IntegrationReactSelect from '../Common/IntegrationReactSelect';
import { timesheetActions, userActions } from '../../_actions';
import { connect } from 'react-redux';
import { compose } from "recompose";

import "react-big-calendar/lib/css/react-big-calendar.css";
import 'moment/locale/nb';
const formatter = 'YYYY-MM-DD';

const styles = theme => ({
    title: {
        flex: '0 0 auto',
    },
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
    },
});

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            TimesheetId: '',
            selectedUserId: props.user.id,
            calendarType: 'Personal'
        };
    }

    componentDidMount() {
        this.props.dispatch(timesheetActions.getAllByDepartmentId(this.props.user.departmentId, this.props.user.id));
        this.props.dispatch(timesheetActions.getWokingHours(this.props.user.departmentId, this.props.user.id));
        this.props.dispatch(userActions.getAll());
    }

    componentWillReceiveProps(nextProps) {
        //for DarkTheme
        nextProps.cookies.get('checkedDarkTheme') === 'true' ? require('./DarkTimeDiagram.css') : require('./LightTimeDiagram.css')
    }

    handleSelect = ({ title, data }) => {
        if (title && data.TimesheetId) {
            this.setState({
                open: true,
                TimesheetId: data.TimesheetId
            })
        }
        else {
            this.setState({
                selectedUserId: data.CreatedUserId,
                calendarType: 'Personal'
            })
        }
    }

    handleClose = () => {
        this.setState({
            open: false
        })
    }

    handleSelectData = (data) => {
        this.setState({
            selectedUserId: data.id,
            calendarType: 'Personal'
        })
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value
        });
    };

    render() {
        const { classes, user, users, timesheet } = this.props;
        const calendarData = timesheetDataProcessing(timesheet.items, this.state.selectedUserId);
        const localizer = Calendar.momentLocalizer(moment);
        const calendarGroupData = timesheetTeamDataProcessing(timesheet.itemsGetWorkingHours, user.departmentId);

        return (
            <div>
                <Paper className={classes.root}>
                    <Toolbar className={classes.root}>
                        <div className={classes.title}>
                            <CardHeader color="danger">
                                <div style={{ height: '5vh' }}>Time Diagram</div>
                            </CardHeader>
                        </div>
                        <div style={{ width: '20%' }}>
                            <IntegrationReactSelect
                                disabledDefaultOptions={true}
                                handleSelectData={this.handleSelectData}
                                options={convertUsersOptions(users.items, this.props.user.departmentId)}
                                valid={true}
                                value={this.state.selectedUserId}
                                placeholder='User'
                            />
                        </div>
                        <FormLabel style={{ margin: '10px' }}>Type</FormLabel>
                        <RadioGroup
                            aria-label="CalendarType"
                            name="calendarType"
                            className={classes.group}
                            value={this.state.calendarType}
                            onChange={this.handleChange('calendarType')}
                        >
                            <FormControlLabel value="Personal" control={<Radio />} label="Personal" />
                            <FormControlLabel value="Team" control={<Radio />} label="Team" />
                        </RadioGroup>
                    </Toolbar>
                    <Calendar
                        toolbar={true}
                        resizable
                        culture='en-GB'
                        localizer={localizer}
                        defaultDate={moment().toDate()}
                        defaultView="month"
                        events={this.state.calendarType === 'Personal' ? calendarData : calendarGroupData}
                        onSelectEvent={this.handleSelect}
                        style={{ height: "120vh", padding: "10px" }}
                        startAccessor="start"
                        endAccessor="end"
                        views={['month']}
                        popup
                        eventPropGetter={
                            (event, start, end, isSelected) => {
                                let newStyle = {
                                    backgroundColor: "#c8e6c9",
                                    color: 'black',
                                    borderRadius: "1px",
                                };

                                if (event.todayWorkingHours < 8) {
                                    newStyle.backgroundColor = "#efebe9"
                                }
                                else if (event.todayWorkingHours === 8) {
                                    newStyle.backgroundColor = "#c8e6c9"
                                }
                                else if (event.todayWorkingHours > 8) {
                                    newStyle.backgroundColor = "#ffcc80"
                                }

                                return {
                                    className: "",
                                    style: newStyle
                                };
                            }
                        }
                        dayPropGetter={
                            (event) => {
                                if (moment(event).format(formatter) === moment(new Date()).format(formatter)) {
                                    return {
                                        className: 'today',
                                        style: {
                                            backgroundColor: '#78909c'
                                        },
                                    };
                                }
                            }
                        }
                    />
                </Paper>
                {
                    user.departmentLocate === 'TW' ?
                        <ReadOnlyFormComponentTW
                            open={this.state.open}
                            close={this.handleClose}
                            TimesheetId={this.state.TimesheetId}
                        />
                        :
                        <ReadOnlyFormComponent
                            open={this.state.open}
                            close={this.handleClose}
                            TimesheetId={this.state.TimesheetId}
                        />
                }
            </div>
        );
    }
}

function timesheetDataProcessing(data, userId) {
    const timesheetData = data ? data.filter(function (element) {
        if (element.CreatedUserId === userId) {
            return true
        }

        return null
    }) : [];

    const calendarData = timesheetData.map(element => {
        const json = {
            id: element.TimesheetId,
            title: (element.ProjectName !== null && element.TaskName !== null) ? parseFloat(element.Hours) + parseFloat(element.HoursOvertime) + ' [' + element.ProjectName + '] ' + element.TaskName + ' - ' + element.Notes : parseFloat(element.Hours) + parseFloat(element.HoursOvertime) + ' Notes: ' + element.Notes,
            start: moment(element.Date).toDate(),
            end: moment(element.Date).toDate(),
            data: element,
        }

        return json
    })

    return calendarData
}

function timesheetTeamDataProcessing(data, departmentId) {
    const timesheetData = data ? data.filter(function (element) {
        return element.DepartmentId === departmentId
    }) : [];

    const calendarData = timesheetData.map((element, index) => {
        const json = {
            id: index,
            todayWorkingHours: element.TodayWorkingHours,
            title: parseFloat(element.TodayWorkingHours) + parseFloat(element.TodayWorkingHoursOvertime) + ' Hours - ' + element.UserName,
            start: moment(element.Date).toDate(),
            end: moment(element.Date).toDate(),
            data: element,
        }

        return json
    })

    return calendarData
}

function convertUsersOptions(data, departmentId) {
    const options = data ? data.filter(findDepartmentId).map((data) => ({
        label: data.UserName,
        id: data.UserId,
        type: 'User'
    })) : [];

    function findDepartmentId(element) {
        if (element.UserStatus === 'A' && element.DepartmentId === departmentId) {
            return true
        }
    }

    return options
}


function mapStateToProps(state) {
    const { user } = state.authentication;
    const { users, timesheet } = state;

    return {
        user,
        users,
        timesheet
    };
}

App.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default compose(connect(mapStateToProps), withStyles(styles))(withCookies(App));


// WEBPACK FOOTER //
// ./src/components/TimeDiagram/App.js